import React, { useEffect, useState } from "react";
import Error from "../../../shared/components/Error";
import { withTranslation } from "react-i18next";
import HouseholdTypeView from "./components/HouseholdTypeView";

const HouseholdType = ({ i18n }) => {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title = "Household Type - HARP- Government of Nova Scotia";
    } else {
      document.title =
        "Household Type - Allocation pour services à domicile chez les aînés - Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  return isError ? <Error /> : <HouseholdTypeView setIsError={setIsError} />;
};

export default withTranslation("common")(HouseholdType);
